import JSONApiService from "@/services/JSONApiService";
import { TODO_MODEL } from "@/models/todo-model";
import { USER_MODEL } from "@/models/user-model";

const settingsApi = ({ commit } = {}) => ({
  getTodos: async userId =>
    JSONApiService(commit)
      .one(USER_MODEL, userId)
      .all(TODO_MODEL)
      .get()
});

export default settingsApi;
